import McpConnectionForm from "../Components/ComoAgents/McpConnectionForm";

const McpConnectionFormPage = () => {
  return <McpConnectionForm />;
};

export default McpConnectionFormPage;
